import Container from '../componants/Container'
import LocationMasterContent from './LocationMasterDetails/LocationMasterContent'

const LocationMaster = () => {
  return (
    <Container>
      <LocationMasterContent />
    </Container>
  )
}

export default LocationMaster